import type { ButtonProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export interface LoadingButtonProps extends ButtonProps {
  onLoading?: (loading: boolean | undefined) => void;
}

export function LoadingButton({ loading, onClick, onLoading, ...props }: LoadingButtonProps) {
  const [isLoading, setIsLoading] = useState(loading);

  const onClickRef = useRef(onClick);
  const onLoadingRef = useRef(onLoading);

  onClickRef.current = onClick;
  onLoadingRef.current = onLoading;

  const onClick_ = useCallback(async (e: React.MouseEvent<HTMLButtonElement>) => {
    setIsLoading(true);
    try {
      await onClickRef.current?.(e);
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useLayoutEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useLayoutEffect(() => {
    onLoadingRef.current?.(isLoading);
  }, [isLoading]);

  return <Button {...props} loading={isLoading} onClick={onClick_}></Button>;
}
